module.exports = __webpack_public_path__ + "media/images/people/boy-4-15fc973022b14bdba35d1c599cfd68f7.webp";